import get from 'lodash/get';
import React from 'react'
import { useTranslation } from 'react-i18next';
import HistoryBlock, { processHistory } from './HistoryBlock';

const HistoryMediaConsent = ({device}) => {
  const { t } = useTranslation();

  return (
    <HistoryBlock
      title={t("devices.MediaConsentHistory")}
      data={
        processHistory("media_consent")(get(device, 'history.media_consent'))}
      cloumnTitle="Geomedia consent"
      cloumnAccessor={"media_consent"}
    />
   );
}

export default HistoryMediaConsent;